import React from 'react';

var Copyright = function Copyright(_ref) {
  var productName = _ref.productName;
  var currentyear = new Date().getFullYear();
  return React.createElement("span", null, "Copyright \xA9", ' ', currentyear, ' ', productName);
};

Copyright.defaultProps = {
  productName: null
};
export default Copyright;